
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexOgSfs3Eb6sMeta } from "/codebuild/output/src147366653/src/pages/index.vue?macro=true";
import { default as aboutEZeIqzR0hgMeta } from "/codebuild/output/src147366653/src/pages/about.vue?macro=true";
import { default as dataR05dnJx2GEMeta } from "/codebuild/output/src147366653/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionxzC609gQQ9Meta } from "/codebuild/output/src147366653/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningFOoFO0LIPzMeta } from "/codebuild/output/src147366653/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyrGWsLlJkZMMeta } from "/codebuild/output/src147366653/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45accountSJgb6HK5hYMeta } from "/codebuild/output/src147366653/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statuejDgjIO3mvbMeta } from "/codebuild/output/src147366653/src/pages/account-settings/statue.vue?macro=true";
import { default as supportfN8mcLmBVGMeta } from "/codebuild/output/src147366653/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsgiCTgdxcHoMeta } from "/codebuild/output/src147366653/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountAShT8fv3LMMeta } from "/codebuild/output/src147366653/src/pages/activate-account.vue?macro=true";
import { default as companyxYltb5FaSeMeta } from "/codebuild/output/src147366653/src/pages/admin/company.vue?macro=true";
import { default as consents730rzP01H2Meta } from "/codebuild/output/src147366653/src/pages/admin/consents.vue?macro=true";
import { default as leadsXJxv32Mi4EMeta } from "/codebuild/output/src147366653/src/pages/admin/leads.vue?macro=true";
import { default as paymentsMd7Hb1FIWKMeta } from "/codebuild/output/src147366653/src/pages/admin/payments.vue?macro=true";
import { default as premium8oJWkBscjYMeta } from "/codebuild/output/src147366653/src/pages/admin/premium.vue?macro=true";
import { default as profiles6yHnS75k3FMeta } from "/codebuild/output/src147366653/src/pages/admin/profiles.vue?macro=true";
import { default as usersR8MAYfdrt4Meta } from "/codebuild/output/src147366653/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordeljsQTH5D6Meta } from "/codebuild/output/src147366653/src/pages/change-password.vue?macro=true";
import { default as _91id_93aZ6OZsDLzpMeta } from "/codebuild/output/src147366653/src/pages/chat/[id].vue?macro=true";
import { default as aiJ0rej1khiOMeta } from "/codebuild/output/src147366653/src/pages/chat/ai.vue?macro=true";
import { default as indexjunYWeohLkMeta } from "/codebuild/output/src147366653/src/pages/chat/index.vue?macro=true";
import { default as chatmKq1E6ZpFWMeta } from "/codebuild/output/src147366653/src/pages/chat.vue?macro=true";
import { default as _91id_939OQd412BZXMeta } from "/codebuild/output/src147366653/src/pages/client/profile/[id].vue?macro=true";
import { default as indexZglTEKEG3ZMeta } from "/codebuild/output/src147366653/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_932usSqeMnOPMeta } from "/codebuild/output/src147366653/src/pages/contacts/[id].vue?macro=true";
import { default as indexiBbyZT0JUAMeta } from "/codebuild/output/src147366653/src/pages/contacts/index.vue?macro=true";
import { default as contactsJryePS8aDPMeta } from "/codebuild/output/src147366653/src/pages/contacts.vue?macro=true";
import { default as _91userId_93l6fvIoJNx5Meta } from "/codebuild/output/src147366653/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as index5qMsKUSeLMMeta } from "/codebuild/output/src147366653/src/pages/login/index.vue?macro=true";
import { default as register_45successu1BpLbebvmMeta } from "/codebuild/output/src147366653/src/pages/login/register-success.vue?macro=true";
import { default as loginFsjOyNES7GMeta } from "/codebuild/output/src147366653/src/pages/login.vue?macro=true";
import { default as logoutBpyPs3E4dtMeta } from "/codebuild/output/src147366653/src/pages/logout.vue?macro=true";
import { default as consentsIljXecmOjyMeta } from "/codebuild/output/src147366653/src/pages/manager/consents.vue?macro=true";
import { default as integrations7TfE2oirjSMeta } from "/codebuild/output/src147366653/src/pages/manager/integrations.vue?macro=true";
import { default as leadsc6nbHUR3ccMeta } from "/codebuild/output/src147366653/src/pages/manager/leads.vue?macro=true";
import { default as payments5Qg1WEDkqNMeta } from "/codebuild/output/src147366653/src/pages/manager/payments.vue?macro=true";
import { default as profileTg2lIGXIgPMeta } from "/codebuild/output/src147366653/src/pages/manager/profile.vue?macro=true";
import { default as teamIMz4qKqLyEMeta } from "/codebuild/output/src147366653/src/pages/manager/team.vue?macro=true";
import { default as index4J4bZTRa83Meta } from "/codebuild/output/src147366653/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientJGIxzLEyiHMeta } from "/codebuild/output/src147366653/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src147366653/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceNNGhBrwUX8Meta } from "/codebuild/output/src147366653/src/pages/marketplace.vue?macro=true";
import { default as subscribei9VwxpGsF7Meta } from "/codebuild/output/src147366653/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46clientO5RczjuOFSMeta } from "/codebuild/output/src147366653/src/pages/orders/find.client.vue?macro=true";
import { default as my_46client2OTa5XAeDQMeta } from "/codebuild/output/src147366653/src/pages/orders/my.client.vue?macro=true";
import { default as privacytbhSgae5DPMeta } from "/codebuild/output/src147366653/src/pages/privacy.vue?macro=true";
import { default as indexNdNCVVwcLkMeta } from "/codebuild/output/src147366653/src/pages/recover/index.vue?macro=true";
import { default as success304sR2EBG8Meta } from "/codebuild/output/src147366653/src/pages/register/success.vue?macro=true";
import { default as _91id_93MVBmz1tikvMeta } from "/codebuild/output/src147366653/src/pages/sales/profile/[id].vue?macro=true";
import { default as index7iGp4OAxAUMeta } from "/codebuild/output/src147366653/src/pages/sales/profile/index.vue?macro=true";
import { default as statueNmVT3ZY18iMeta } from "/codebuild/output/src147366653/src/pages/statue.vue?macro=true";
import { default as successD556TZ3EVUMeta } from "/codebuild/output/src147366653/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubLfgrvUSp8GMeta } from "/codebuild/output/src147366653/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubLfgrvUSp8G } from "/codebuild/output/src147366653/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexOgSfs3Eb6sMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutEZeIqzR0hgMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutEZeIqzR0hgMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsgiCTgdxcHoMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsgiCTgdxcHoMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src147366653/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountAShT8fv3LMMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountAShT8fv3LMMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companyxYltb5FaSeMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companyxYltb5FaSeMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consents730rzP01H2Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consents730rzP01H2Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsXJxv32Mi4EMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsXJxv32Mi4EMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsMd7Hb1FIWKMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsMd7Hb1FIWKMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premium8oJWkBscjYMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premium8oJWkBscjYMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profiles6yHnS75k3FMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profiles6yHnS75k3FMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersR8MAYfdrt4Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersR8MAYfdrt4Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordeljsQTH5D6Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordeljsQTH5D6Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/change-password.vue")
  },
  {
    name: chatmKq1E6ZpFWMeta?.name,
    path: "/en/chat",
    meta: chatmKq1E6ZpFWMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93aZ6OZsDLzpMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiJ0rej1khiOMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: indexjunYWeohLkMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chatmKq1E6ZpFWMeta?.name,
    path: "/pl/chat",
    meta: chatmKq1E6ZpFWMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93aZ6OZsDLzpMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiJ0rej1khiOMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: indexjunYWeohLkMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_939OQd412BZXMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_939OQd412BZXMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexZglTEKEG3ZMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexZglTEKEG3ZMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/client/profile/index.vue")
  },
  {
    name: contactsJryePS8aDPMeta?.name,
    path: "/en/contacts",
    meta: contactsJryePS8aDPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_932usSqeMnOPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexiBbyZT0JUAMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsJryePS8aDPMeta?.name,
    path: "/pl/contacts",
    meta: contactsJryePS8aDPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_932usSqeMnOPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexiBbyZT0JUAMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93l6fvIoJNx5Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93l6fvIoJNx5Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexOgSfs3Eb6sMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexOgSfs3Eb6sMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/index.vue")
  },
  {
    name: loginFsjOyNES7GMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src147366653/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: index5qMsKUSeLMMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45successu1BpLbebvmMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: loginFsjOyNES7GMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src147366653/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: index5qMsKUSeLMMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45successu1BpLbebvmMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutBpyPs3E4dtMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutBpyPs3E4dtMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsIljXecmOjyMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsIljXecmOjyMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrations7TfE2oirjSMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrations7TfE2oirjSMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsc6nbHUR3ccMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsc6nbHUR3ccMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: payments5Qg1WEDkqNMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: payments5Qg1WEDkqNMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profileTg2lIGXIgPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profileTg2lIGXIgPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: teamIMz4qKqLyEMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: teamIMz4qKqLyEMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/manager/team.vue")
  },
  {
    name: marketplaceNNGhBrwUX8Meta?.name,
    path: "/en/marketplace",
    meta: marketplaceNNGhBrwUX8Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src147366653/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientJGIxzLEyiHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceNNGhBrwUX8Meta?.name,
    path: "/pl/marketplace",
    meta: marketplaceNNGhBrwUX8Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src147366653/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientJGIxzLEyiHMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribei9VwxpGsF7Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribei9VwxpGsF7Meta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46clientO5RczjuOFSMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46clientO5RczjuOFSMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46client2OTa5XAeDQMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46client2OTa5XAeDQMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src147366653/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacytbhSgae5DPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacytbhSgae5DPMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexNdNCVVwcLkMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexNdNCVVwcLkMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src147366653/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src147366653/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93MVBmz1tikvMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93MVBmz1tikvMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index7iGp4OAxAUMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index7iGp4OAxAUMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statueNmVT3ZY18iMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statueNmVT3ZY18iMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successD556TZ3EVUMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successD556TZ3EVUMeta || {},
    component: () => import("/codebuild/output/src147366653/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubLfgrvUSp8GMeta?.name,
    path: "/old-page",
    component: component_45stubLfgrvUSp8G
  }
]